import { navigate } from '@reach/router'
import { RECAPTCHA_TOKEN } from 'constants/index'
import { RootState } from 'context'
import { setLogin, setProblem } from 'context/reducer/app'
import { QuotaState } from 'interfaces/quota'
import { useEffect, useState } from 'react'
import { useRecaptcha } from 'react-recaptcha-hook'
import { useDispatch, useSelector } from 'react-redux'
import encrypt from 'utils/encrypt'
import { URL_PATH } from 'utils/global'

const useFetchLogin = (flujo: string) => {

  const { amount, term, fee, rate, destination } = useSelector<RootState, QuotaState>((state) => state.quota)
  const dispatch = useDispatch()
  const [error, setError] = useState(0)
  const [loader, setLoader] = useState(false)
  // Captcha
  const execute = useRecaptcha({
    hideDefaultBadge: true,
    sitekey: process.env.REACT_APP_KEY_CAPTCHA!,
  })

  const createRequest = (selectInput: string, identification: string, inputValue?: string) => {
    return {
      cellphone: selectInput === 'cellphone' ? encrypt(inputValue) : null,
      email: selectInput === 'email' ? encrypt(inputValue) : null,
      identification: encrypt(identification),
      simulation: {
        amount: amount,
        term: term,
        fee: fee,
        rate: rate,
        loanDestination: destination,
      }
    }
  }

  const getToken = async () => {
    let token
    if (process.env.REACT_APP_USE_RECAPTCHA === 'true' && flujo !== 'agencia') {
      token = ((await execute('login')) as unknown) as string
    } else {
      token = RECAPTCHA_TOKEN
    }
    return token
  }

  const dispatchLogin = (adviser: string, identification: string,
    data: any, selectInput: string, inputValue: string) => {
    dispatch(setLogin({
      adviser,
      identification,
      email: data.email,
      phone: data.cellphone,
      phoneInput: selectInput === 'cellphone' ? encrypt(inputValue) : null,
      emailInput: selectInput === 'email' ? encrypt(inputValue) : null,
      firstName: data.firstName,
      fullName: data.fullName,
      remainingTime: data.remainingTime
    }))
  }

  useEffect(() => {
    const clickLogin = async (e: any) => {
      const {
        identification,
        adviser,
        emailPhoneSelect: selectInput,
        emailPhoneValue: inputValue,
      } = e.detail
      setLoader(true)
      setError(0)

      const token = await getToken()
      fetch(`${process.env.REACT_APP_URL_AUTH}validate/contact`, {
        body: JSON.stringify(createRequest(selectInput, identification, inputValue)),
        headers: {
          Accept: 'application/json',
          Authorization: token,
          'Content-Type': 'application/json',
        },
        method: 'POST',
        mode: 'cors',
      })
        .then((response) => response.json())
        .then((data: any) => {
          if (data.code === '0') {
            dispatchLogin(adviser, identification, data, selectInput, inputValue)
            navigate(`${URL_PATH()}otp${window.location.search}`)
          } else if ([2000, 2101, 2001, 9000, 3, 4].includes(+data.code)) {
            setError(+data.code)
          } else {
            dispatch(setProblem({ open: true, code: data.code, message: data.firstName }))
          }
          setLoader(false)
        })
        .catch(() => {
          dispatch(setProblem({ open: true, code: '0007' }))
        })
    }
    document.addEventListener('eventClickButtonLogin', clickLogin)
    return () =>
      document.removeEventListener('eventClickButtonLogin', clickLogin)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [execute])

  return { error, loader }
}

export default useFetchLogin
